import * as React from 'react';
import './BasicPopup.scss';
import Popup from './Popup'

import PopupService from '../../services/popup.service'

interface Props {
  title: string;
  text?: string;

  type?: 'danger' | 'default' | 'success' | 'warning';
  confirmText?: string;
  confirmColor?: string;

  icon?: string;
  iconColor?: string;
  onConfirm?(): void;
}

const BasicPopup: React.SFC<Props> = (props) => {
    return (
      <Popup
        warning
        outside
        title={props.title}

        type={props.type}
        icon={props.icon}
        iconColor={props.iconColor}
      >
        <div className='basic-popup-container'>
          { props.text && (
            <div className='basic-popup-text'>
              {props.text}
            </div>
          )}
          { (props.onConfirm || props.confirmText) && (
            <div className='centered'>
              <div
                className="btn btn-primary"
                onClick={props.onConfirm || PopupService.hide}
              >
                {props.confirmText || 'OK'}
              </div>
            </div>
          )}
        </div>
      </Popup>
    );
}

export default BasicPopup;
